import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Container, Badge } from "reactstrap";

import Mp3Player from "../../components/Mp3Player/AudioPlayer";

export default function Recitation() {
  const { surahId } = useParams();
  const [recitation, setRecitation] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/surah/reciters`)
      .then((rec) => {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/surah/recitation?surahId=${surahId}&reciterId=${rec.data[0].id}`
          )
          .then((res) => {
            setRecitation(res.data[0]);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [surahId]);

  if (!recitation) return null;
  return (
    <Container>
      <h4 className="pb-1">
        Reciter <Badge color="primary">{recitation.reciter.name}</Badge>{" "}
      </h4>
      <Mp3Player src={`${process.env.REACT_APP_RECEITATION_BASE_URL}${recitation.audioUrl}`} />
    </Container>
  );
}
